import { render, staticRenderFns } from "./LocalSystems.vue?vue&type=template&id=45b85e02"
import script from "./LocalSystems.vue?vue&type=script&lang=js"
export * from "./LocalSystems.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports